export const DISCONNECTED= 'DISCONNECTED';
export const CALLING= 'CALLING';
export const RINGING= 'RINGING';
export const OUTGOINGCALL= 'OUTGOINGCALL';
export const INCOMINGCALL= 'INCOMINGCALL';
